import FormFieldInput from './form-field-input';
import FormFieldOmbudType from './form-field-retailer-type';
import FormFieldTextarea from './form-field-text-area';
import { getClassNamesFromArray } from '@common/utils';
import './styles.less';
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const RetailerFormFields = () => <Grid>
    <GridRow>
      <GridCol am={6}>
        <FormFieldOmbudType />
      </GridCol>
    </GridRow>
    <GridRow className="text-area-top">
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="companyName" required title="Inregistrerat företagsnamn *" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="orgNumber" pattern="^[0-9+\\s-]{6,}$" placeholder="123456-7890" required title="Organisationsnummer *" type="text" />
      </GridCol>
      <GridCol am={6} lg={4} />
    </GridRow>
    <GridRow className="text-area-top">
      <GridCol am={6} className="field-col" lg={4} md={4}>
        <FormFieldInput id="signatoryName" required title="Firmatecknare * " />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4} md={4}>
        <FormFieldInput id="signatorySsn" pattern="^[0-9+\\s-]{6,}$" placeholder="ÅÅÅÅMMDD-XXXX" required title="Personnummer (firmatecknare) * " type="text" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4} md={4}>
        <FormFieldInput id="signatoryMobilePhone" pattern="^[0-9+\\s-]{6,}$" placeholder="0701234567" required title="Mobiltelefon (firmatecknare) *" type="number" />
      </GridCol>
      <GridCol am={6} className={getClassNamesFromArray(['field-col', 'field-margin-top'])} lg={4} md={4}>
        <FormFieldInput id="signatoryEmail" required title="E-postadress (firmatecknare) * " type="email" />
      </GridCol>
      <GridCol am={6} lg={4} md={4} />
      <GridCol am={6} lg={4} md={4} />
    </GridRow>

    <GridRow className="text-area-top">
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="storeName" required title="Butiksnamn * " />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="storeAddress" required title="Butikens gatuadress * " />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="storePostalCode" required title="Postnummer * " type="number" />
      </GridCol>
    </GridRow>

    <GridRow>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="storeCity" required title="Ort * " />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="storePhone" pattern="^[0-9+\\s-]{6,}$" placeholder="08-123 456 78" required title="Butikens telefon inkl. riktnr * " type="number" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="storeMobilePhone" pattern="^[0-9+\\s-]{6,}$" placeholder="0701234567" required title="Mobilnr till butik * " type="number" />
      </GridCol>
    </GridRow>
    <GridRow>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="storeEmail" required title="E-post till butik * " type="email" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="contactName" required title="Kontaktperson* " />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="contactMobilePhone" pattern="^[0-9+\\s-]{6,}$" placeholder="0701234567" required title="Mobiltelefon (kontaktperson)* " type="number" />
      </GridCol>
      <GridCol am={6} className={getClassNamesFromArray(['field-col', 'field-margin-top'])} lg={4}>
        <FormFieldInput id="contactEmail" required title="E-postadress (kontaktperson)* " type="email" />
      </GridCol>
      <GridCol am={6} lg={4} />
      <GridCol am={6} lg={4} />
    </GridRow>
    <span className="title">Om annan adress än ovanstående:</span>
    <GridRow>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="deliveryAddress" title="Leveransadress" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="deliveryPostalCode" title="Postnummer (leveransadress)" type="number" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="deliveryCity" title="Ort (leveransadress)" />
      </GridCol>
    </GridRow>
    <GridRow className="text-area-top">
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="customersPerWeek" required title="Antal kunder per vecka *" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="manualRegisters" required title="Antal manuella kassor *" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="reconciliationRegisters" title="Antal avstämningskassor" />
      </GridCol>

    </GridRow>

    <GridRow className="text-area-top">
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="selfCheckoutRegisters" title="Antal självscanningkassor" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="inStoreRegisters" title="Antal kassor i förbutik" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="turnoverMSek" pattern="^[0-9]+([.,][0-9]{1,2})?$" required title="Butikens årsomsättning (mkr) * " />
      </GridCol>

    </GridRow>

    <GridRow>
      <GridCol am={6} lg={4}>
        <FormFieldInput id="prospectChain" title="Kedjetillhörighet" />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="hoursWeekdays" required title="Öppettider måndag-fredag * " />
      </GridCol>
      <GridCol am={6} className="field-col" lg={4}>
        <FormFieldInput id="hoursSaturday" required title="Öppettider lördag * " />
      </GridCol>
      <GridCol am={6} className={getClassNamesFromArray(['field-col', 'field-margin-top'])} lg={4}>
        <FormFieldInput id="hoursSunday" required title="Öppettider söndag * " />
      </GridCol>
      <GridCol am={6} lg={4} />
      <GridCol am={6} lg={4} />
    </GridRow>
    <GridRow className="text-area-top">
      <GridCol className="field-col" lg={12}>
        <FormFieldTextarea id="comment" title="Kommentar" />
      </GridCol>
    </GridRow>
  </Grid>;
export default RetailerFormFields;